const yup = require("../interface/yup-br");

export const PictureSchema = yup.object().shape({
    titulo: yup.string().required(),
    arquivo: yup.string()
});

